import _ from "lodash";
import React from "react";
import "./style.module.scss";
class Select extends React.Component {
  renderOption = () => {
    const { data = [] } = this.props;
    return data.map((item, i) => {
      return (
        <option key={i} value={_.isUndefined(item.id) ? item.code : item.id}>
          {item.name}
        </option>
      );
    });
  };

  handleChange = e => {
    const id = e.target.value;
    this.props.onChange(id);
  };

  handleChangeWithObject = event => {
    const options = event.target.options;
    const index = options.selectedIndex;
    const id = options[index].value;
    const name = options[index].text;
    const data = { id, name };
    const { onChange } = this.props;
    onChange(data);
  };

  render() {
    const { value, disabled, isReturnObject } = this.props;
    return (
      <select
        value={value}
        onChange={
          !isReturnObject ? this.handleChange : this.handleChangeWithObject
        }
        disabled={disabled}
        className="browser-default custom-select"
      >
        {this.renderOption()}
      </select>
    );
  }
}

export default Select;
